import FavoritesList from '@/Component/Brand/SaveList/FavoritesList'

const FavoritesPage = () => {
  return (
    <FavoritesList />
  )
}

export default FavoritesPage
